import { IClientValidator } from "./IClientValidator.js";

    /** Works with inheritors of ChannelIslandsAttribute.cs to perform unobtrusive validation in MVC against country and postal code input elements.
     *  Used by the checkout/order-summary page.
     * 
     * This class is used by the jersey / guernsey postal and country code validators below and is not directly instantiated.
     */
    export abstract class ChannelIslands implements IClientValidator {
        public validate(value: string, element: HTMLInputElement, params): boolean {
            let countrySelect = <HTMLSelectElement>document.getElementById(params.countryfieldid);

            if (!countrySelect || countrySelect.selectedIndex < 0) {
                return true;
            }

            let selectedCountryOption = countrySelect.options[countrySelect.selectedIndex];

            if (selectedCountryOption.value == params.countrycode) {
                if (params.muststartwith) {
                    return this.postalCodeStartsWith(value, params.postalcode);
                }
                else if (params.mustnotstartwith) {
                    return !this.postalCodeStartsWith(value, params.postalcode);
                }
            }

            return true;
        }

        private postalCodeStartsWith(postalCode: string, prefix: string): boolean {
            if (!postalCode) {
                return false;
            }

            if (postalCode.toUpperCase().trim().startsWith(prefix)) {
                return true;
            }
            return false;
        }
    }

    export class JerseyPostal extends ChannelIslands {
        public validate(value: string, element: HTMLInputElement, params): boolean {
            return super.validate(value, element, params);
        }
    }

    export class JerseyCountry extends ChannelIslands {
        public validate(value: string, element: HTMLInputElement, params): boolean {
            return super.validate(value, element, params);
        }
    }

    export class GuernseyPostal extends ChannelIslands {
        public validate(value: string, element: HTMLInputElement, params): boolean {
            return super.validate(value, element, params);
        }
    }

    export class GuernseyCountry extends ChannelIslands {
        public validate(value: string, element: HTMLInputElement, params): boolean {
            return super.validate(value, element, params);
        }
    }

window.validators = window.validators || {};
window.validators.jerseypostal = new JerseyPostal();
window.validators.jerseycountry = new JerseyCountry();
window.validators.guernseypostal = new GuernseyPostal();
window.validators.guernseycountry = new GuernseyCountry();
